import { motion } from "@/components/motion";
import { Flame, Wrench, ShieldCheck, Truck } from "lucide-react";

const services = [
  {
    icon: Flame,
    title: "Fire & Safety Solutions",
    desc: "Complete fire detection, alarm, sprinkler, and hydrant systems — supply, installation, testing & AMC.",
  },
  {
    icon: Wrench,
    title: "Custom Fabrication",
    desc: "Custom size pipes and tubes cut to your exact specifications for specialized industrial projects.",
  },
  {
    icon: ShieldCheck,
    title: "Quality Assurance",
    desc: "All materials are ISI-certified and sourced from reliable manufacturers meeting industry standards.",
  },
  {
    icon: Truck,
    title: "Bulk Supply & Delivery",
    desc: "Large-volume supply with timely delivery across Tamil Nadu, Kerala, Bangalore, Mumbai, and pan-India.",
  },
];

const Services = () => (
  <section id="services" className="py-20 md:py-28 bg-primary">
    <div className="container mx-auto px-4">
      <div className="text-center mb-14">
        <p className="text-accent font-display text-sm uppercase tracking-[0.2em] mb-2">
          What We Do
        </p>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-primary-foreground">
          Our Services
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="text-center p-6 rounded-lg border border-primary-foreground/10 hover:bg-primary-foreground/5 transition"
          >
            <s.icon className="w-10 h-10 text-accent mx-auto mb-4" />
            <p className="font-display text-lg font-semibold text-primary-foreground mb-2">
              {s.title}
            </p>
            <p className="font-body text-primary-foreground/70 text-sm leading-relaxed">
              {s.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
